<template>
    <!-- <app-layout> -->

    <div class="py-12 w-full">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

            <div class="flex flex-row">
                <div class="flex flex-col flex-grow">
                    <h1 class="text-blue-500 text-3xl font-bold">How do you want to use {{ app_name }}?</h1>
                    <p class="pb-8 text-gray-500 text-lg">Don’t worry, you’ll be able to switch anytime.</p>
                </div>
                <div class="flex flex-col justify-start">
                    <inertia-link :href="route('library.incoming')" @click="skip"
                        class="inline-flex items-center px-4 py-2 font-semibold text-xs text-gray-600 uppercase tracking-widest hover:text-gray-500  active:text-gray-800 transition mt-1">
                        Skip <span class="hidden md:inline ml-1">onboarding</span>
                        <!-- <vue-feather type="arrow-right" class="h-4 w-4 ml-2"></vue-feather> -->
                    </inertia-link>
                </div>
            </div>

            <div class="grid grid-cols-3 gap-16 mx-auto mt-5">

                <inertia-link class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10
                    cursor-pointer transform hover:scale-105 transition duration-200
                    flex flex-col justify-center items-center text-center"
                    :href="route('quick_start', { tab: 'helpdesk', tab2: 'intercom' })">
                    <!-- <p class="text-blue-500 text-3xl font-bold">Intercom</p> -->
                    <p><img src="/img/intercom-full-dark.svg" alt="logo" class="w-4/5 max-w-xs my-4 mx-auto" /></p>
                    <!-- <p class="text-gray-500">Increase ticket resolution speed and improve the customer experience.</p> -->
                </inertia-link>

                <inertia-link class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10
                    cursor-pointer transform hover:scale-105 transition duration-200
                    flex flex-col justify-center items-center text-center"
                    :href="route('quick_start', { tab: 'helpdesk', tab2: 'zendesk' })">
                    <!-- <p class="text-blue-500 text-3xl font-bold">Zendesk</p> -->
                    <p><img src="/img/zendesk-full-dark.svg" alt="logo" class="w-full my-4" /></p>
                    <!-- <p class="text-gray-500">Receive feedback directly in your Zendesk customer service center.</p> -->
                </inertia-link>

                <inertia-link class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10
                    cursor-pointer transform hover:scale-105 transition duration-200
                    flex flex-col justify-center items-center text-center"
                    :href="route('quick_start', { tab: 'helpdesk', tab2: 'jira' })">
                    <p><img src="/img/jira-service-management-logo-gradient-blue.png" alt="logo" class="w-full my-4" />
                    </p>
                </inertia-link>

                <inertia-link class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10
                    cursor-pointer transform hover:scale-105 transition duration-200
                    flex flex-col justify-center items-center text-center"
                    :href="route('quick_start', { tab: 'helpdesk', tab2: 'helpscout' })">
                    <p><img src="/img/helpscout-logo.svg" alt="logo" class="w-full my-4 px-12" /></p>
                </inertia-link>

                <inertia-link class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10
                    cursor-pointer transform hover:scale-105 transition duration-200
                    flex flex-col justify-center items-center text-center"
                    :href="route('quick_start', { tab: 'helpdesk', tab2: 'freshchat' })">
                    <p><img src="/img/freshchat-logo.svg" alt="logo" class="w-full my-4 px-10" /></p>
                </inertia-link>

                <inertia-link class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-6
                    cursor-pointer transform hover:scale-105 transition duration-200
                    flex flex-col justify-center items-center text-center"
                    :href="route('quick_start', { tab: 'helpdesk', tab2: 'freshdesk' })">
                    <p><img src="/img/freshdesk-logo.svg" alt="logo" class="w-full my-4 px-10" /></p>
                </inertia-link>

                <inertia-link class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10
                    cursor-pointer transform hover:scale-105 transition duration-200
                    flex flex-col justify-center items-center text-center" :href="route('quick_start', 'standalone')">
                    <p class="text-blue-500 text-2xl font-bold flex flex-row justify-center items-center flex-grow"><img
                            src="/img/birdie-logo.svg" alt="logo" class="w-10 h-10 mr-2" /> Standalone</p>
                    <!-- <p><img src="/img/zest_blue.svg" alt="logo" class="w-16 h-16 my-4" /></p> -->
                    <p class="text-gray-500 mt-4">If you are using another helpdesk or don’t use any helpdesk.</p>
                </inertia-link>

                <inertia-link class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10
                    cursor-pointer transform hover:scale-105 transition duration-200
                    flex flex-col justify-center items-center text-center" :href="route('quick_start', 'inapp')">
                    <!-- <p class="text-blue-500 text-2xl font-bold">In-App</p>
                    <p><img src="/img/zest_blue.svg" alt="logo" class="w-16 h-16 my-4" /></p> -->
                    <p class="text-blue-500 text-2xl font-bold flex flex-row justify-center items-center flex-grow"><img
                            src="/img/birdie-logo.svg" alt="logo" class="w-10 h-10 mr-2" /> In-App</p>
                    <p class="text-gray-500 mt-4">Open {{ app_name }} from a specific button, link or element in your
                        webapp.</p>
                </inertia-link>


            </div>


        </div>
    </div>
    <!-- </app-layout> -->
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'

export default {
    components: {
        AppLayout,
    },
    layout: AppLayout,
    props: [

    ],
    data() {
        return {
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            app_name: this.$page.props.app_name
        }
    },
    created() {
        console.log(this.tab, this.tab2)

    },
    beforeUnmount() {

    },
    mounted() {
        //this.EventBus.emit("start.call", "hello")
    },
    methods: {
        skip() {
            this.set_onboarding_done()
        },
        set_onboarding_done() {
            let url = this.$page.props.api_url + '/v1/user/set_meta';
            var params = {
                meta: "onboarding",
                value: "yes"
            };
            axios.post(url, params)
                .then(response => {
                    if (response.data) {
                        this.$inertia.visit(route('library.incoming'));
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }
}
</script>
